export default __webpack_public_path__ + "static/media/mobile-etapa1.755642a0.jpg";